import Cookies from "js-cookie"
import {refreshToken} from "./userApi"

const TokenKey = 'User_Token';

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token,expires) {
  return Cookies.set(TokenKey, token,{
    expires: expires
  }) 
}
 
export function removeToken() {
  return Cookies.remove(TokenKey)
}
 
export async function refreshesToken(){
  let data = {
    Access_Token: getToken()
  };
  return refreshToken(data).then(res=>{
    if(res.data.Success){
      let userInfo = {};
      let result = res.data.Data;
      setToken(result.TokenInfo.Access_Token, result.TokenInfo.Expires_In);
      userInfo.JobNo = result.JobNo;
      userInfo.Id = result.Id;
      userInfo.Avatar = result.Avatar;
      userInfo.Name = result.Name;
      userInfo.NickName = result.NickName;
      localStorage.setItem('userInfo',JSON.stringify(userInfo));
      return true;
    }else{
      return false;
    }
  },err=>{
    return false;
  })
}
 


// WEBPACK FOOTER //
// ./src/assets/js/modules/auth.js